import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = {
  class: "column",
  style: {"margin":"0 auto"}
}

import Logo from '@/components/common/Logo.vue';
import Photos from '@/components/common/Photos.vue';
import LatestMessages from '@/components/message/LatestMessages.vue';
import ContentBlock from '@/components/content/ContentBlock.vue';
import Schedule from '@/components/schedule/Schedule.vue';
import MainSponsors from '@/components/sponsor/MainSponsors.vue';
import FAQtop from '@/components/faq/FAQtop.vue';
import Menu from '@/components/Menu.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Menu),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ContentBlock, { slug: "theme" })
      ])
    ])
  ]))
}
}

})